import { IHttpApi } from '@cian/http-api/shared';

import { ResponseError } from '../../errors';
import {
  fetchCreateQuestion,
  ICreateQuestionResponse200,
  ICreateQuestionResponse400,
} from '../../repositories/newbuilding-reviews/v1/create-question';
import { ICreateQuestionRequestSchema } from '../../repositories/newbuilding-reviews/entities/create_question/CreateQuestionRequestSchema';

export interface IFetchQuestionParams {
  httpApi: IHttpApi;
  parameters: ICreateQuestionRequestSchema;
}

export async function addQuestion({ httpApi, parameters }: IFetchQuestionParams): Promise<void> {
  const result = await fetchCreateQuestion<ICreateQuestionResponse200, ICreateQuestionResponse400>({
    httpApi,
    parameters,
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'reviews#addQuestion',
      message: `newbuildingId: ${parameters.newbuildingId}`,
    });
  }
}
